import { Select } from '@automata/ui';
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import startCase from 'lodash/startCase';
import React from 'react';

import { LabwareClosureState, LabwareType } from '../../../types';
import { getClosureStateOptionsForLabwareType } from '../../../utils';

export type Props = {
  labwareType: LabwareType;
  value: LabwareClosureState;
  onChange: (newValue: LabwareClosureState) => void;
};

export const ClosureStateSelect = ({ labwareType, value, onChange }: Props) => {
  const items = getClosureStateOptionsForLabwareType(labwareType);

  if (items.length === 0) {
    // if no close state options, do not render this field
    return null;
  }

  return (
    <FormControl fullWidth>
      <Select
        label="Closure state"
        value={value}
        onChange={(e) => {
          const newValue = e.target.value as typeof value;
          onChange(newValue);
        }}
      >
        {items.map((item) => (
          <MenuItem key={item} value={item}>
            {startCase(item)}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
